'use client'

import { useState } from 'react'
import ButtonDefault from 'ui/src/buttons/ButtonDefault'
import ResearcherHeader from '@/components/partsGroups/navigation/ResearcherHeader'
import ResearcherSide from '@/components/partsGroups/navigation/ResearcherSide'
import ResearcherFooter from '@/components/partsGroups/navigation/ResearcherFooter'
import TableProfilePaperEdit from '@/components/partsGroups/tables/TableProfilePaperEdit'
import { useLocale } from '@/features/i18n/hooks/useLocale'
import ModalPhotoEdit from '@/components/partsGroups/modal/ModalPhotoEdit'

export default function PaperEditPage() {
  const { t } = useLocale()
  const [openPhotoModal, setOpenPhotoModal] = useState(false)
  const [selectedImage, setSelectedImage] = useState<string | undefined>(undefined)

  return (
    <>
      <div className="resercherContainer">
        <ResearcherHeader currentMenu="profile" />
        <main className="resercherWrapper">
          <div className="resercherInner">
            <div className="mb-5">
              <h1 className="title-page">{t.profile.Profile}</h1>
            </div>
            <div className="flex gap-5">
              <ResearcherSide
                currentMenu="paper"
                selectImage={(image) => {
                  setSelectedImage(image)
                  setOpenPhotoModal(true)
                }}
              />

              <div className="resercherMain">
                <h2 className="resercherMain__title">{t.profile.ResearchPaper}</h2>
                <TableProfilePaperEdit />
              </div>
            </div>
          </div>
        </main>
        <ResearcherFooter />
        <ModalPhotoEdit
          isOpen={openPhotoModal}
          image={selectedImage}
          onClose={() => setOpenPhotoModal(false)}
        />
      </div>
    </>
  )
}
